import AuthTravelShell from "../../components/travel-theme/AuthTravelShell.js";

const Error = () => {
  return (
    <AuthTravelShell
      eyebrow="Route unavailable"
      title="Wrong connection."
      description="This destination is not on the HackPrinceton Fall 2026 route."
      ticketCode="404"
    >
      <div className="auth-form">
        <p className="subtitle">
          Return to the traveler portal and choose another destination.
        </p>
        <a className="auth-button-link" href="/">
          Return to portal
        </a>
      </div>
    </AuthTravelShell>
  );
};

export default Error;
